import React, { Component } from 'react';
import * as $ from 'jquery';
import { PRIORITY } from './TicketsContainer.js';
import { translate } from 'react-i18next';

class TicketAddition extends Component {

  isSubmitEnabled = () => {
    return this.props.center
      && this.props.department_id
      && this.props.priority
      && this.props.description;
  }

  renderCenter = (center, index) => {
    return (
      <li key={index}>
        <a onClick={() => this.props.handleCenterClick(center)}>
          {center.name}
        </a>
      </li>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          <h4 className="panel-title">{t('dashboard.tickets.heading_add')}</h4>
        </div>
        <div className="panel-body">
          <form method="post" onSubmit={this.props.handleTicketSubmit}>
            <fieldset>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="center">
                      {t('dashboard.tickets.label_center')}
                    </label>
                    <div id="dropdown-div" className="dropdown">
                      <input
                        autoComplete="off"
                        className="dropdown-toggle form-control"
                        data-toggle="dropdown"
                        id="center"
                        onChange={this.props.handleCenterSearch}
                        onClick={() => { $("#dropdown-div").addClass("open") }}
                        placeholder={t('dashboard.events.holder_center')}
                        required
                        type="search"
                        value={this.props.centerQuery} />
                      <ul id="center-results" className="dropdown-menu" style={{ display: 'none' }}>
                        {this.props.centers.map((center, index) => this.renderCenter(center, index))}
                      </ul>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="department">
                      {t('dashboard.tickets.label_department')}
                    </label>
                    <select
                      className="form-control"
                      id="department"
                      onChange={this.props.handleDepartmentChange}
                      required
                      value={this.props.department_id}>
                      <option value="">{t('dashboard.tickets.holder_select')}</option>
                      {this.props.departments.map((department, index) =>
                        <option key={index} value={department.id}>{department.name}</option>
                      )}
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="category">
                      {t('dashboard.tickets.label_category')}
                    </label>
                    <select
                      className="form-control"
                      id="category"
                      onChange={this.props.handleCategoryChange}
                      value={this.props.category_id}>
                      <option value="">{t('dashboard.tickets.holder_select')}</option>
                      {this.props.categories.map((category, index) =>
                        <option key={index} value={category.id}>{category.name}</option>
                      )}
                    </select>
                  </div>
                  {this.props.types.length ? (
                    <div className="form-group">
                      <label htmlFor="type">
                        {t('dashboard.tickets.label_type')}
                      </label>
                      <select
                        className="form-control"
                        id="type"
                        onChange={this.props.handleTypeChange}
                        value={this.props.type_id}>
                        <option value="">{t('dashboard.tickets.holder_select')}</option>
                        {this.props.types.map((type, index) =>
                          <option key={index} value={type.id}>{type.name}</option>
                        )}
                      </select>
                    </div>
                  ) : null}
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="manager">
                      {t('dashboard.tickets.label_manager')}
                    </label>
                    <select
                      className="form-control"
                      id="manager"
                      onChange={this.props.handleManagerChange}
                      value={this.props.manager_id}>
                      <option value="">{t('dashboard.tickets.holder_select')}</option>
                      {this.props.managers.map((manager, index) =>
                        <option key={index} value={manager.id}>{manager.name}</option>
                      )}
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="priority">
                      {t('dashboard.tickets.label_priority')}
                    </label>
                    <div className="radio-group">
                      <label className="radio-inline">
                        <input
                          checked={this.props.priority === PRIORITY.LOW}
                          name="priority"
                          onChange={this.props.handlePriorityChange}
                          type="radio"
                          value={PRIORITY.LOW} />
                        {t('dashboard.tickets.priority_low')}
                      </label>
                      <label className="radio-inline">
                        <input
                          checked={this.props.priority === PRIORITY.MEDIUM}
                          name="priority"
                          onChange={this.props.handlePriorityChange}
                          type="radio"
                          value={PRIORITY.MEDIUM} />
                        {t('dashboard.tickets.priority_medium')}
                      </label>
                      <label className="radio-inline">
                        <input
                          checked={this.props.priority === PRIORITY.HIGH}
                          name="priority"
                          onChange={this.props.handlePriorityChange}
                          type="radio"
                          value={PRIORITY.HIGH} />
                        {t('dashboard.tickets.priority_high')}
                      </label>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="description">
                      {t('dashboard.tickets.label_description')}
                    </label>
                    <textarea
                      className="form-control"
                      id="description"
                      onChange={this.props.handleDescriptionChange}
                      placeholder={t('dashboard.tickets.holder_description')}
                      required
                      rows="5"
                      value={this.props.description} />
                  </div>
                  <div className="form-group">
                    <button
                      className="btn btn-primary"
                      disabled={!this.isSubmitEnabled()}
                      type="submit">
                      {t('dashboard.tickets.btn_add')}
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    );
  }
}

export default translate('common')(TicketAddition);



// WEBPACK FOOTER //
// ./src/dashboard/tickets/TicketAddition.js